import { BodyBold, BodyLight, Heading, Heading2 } from './styles';

export default {
  BodyLight,
  BodyBold,
  Heading,
  Heading2,
};
